module.exports = __webpack_public_path__ + "img/mr.aa72dd9d.svg";